var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1:154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75824 6.84135L1.09487 0.162468C0.917577 -0.0152256 0.434888 -0.0898926 0.183114 0.162468C-0.0686596 0.414828 -0.053296 0.839411 0.183114 1.07635L6.84648 7.75523H1.31132C0.880455 7.75523 0.584972 7.96955 0.584972 8.39604C0.584972 8.82253 0.809539 9.04762 1.31132 9.04762H9.04762V1.29331C9.04762 0.979902 8.82305 0.719271 8.3621 0.719271C7.98388 0.719271 7.75824 0.920668 7.75824 1.29331V6.84135Z",
    fill: "#F39C12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2418 12.1586L17.9051 18.8375C18.0824 19.0152 18.5651 19.0899 18.8169 18.8375C19.0687 18.5852 19.0533 18.1606 18.8169 17.9237L12.1535 11.2448L17.6887 11.2448C18.1195 11.2448 18.415 11.0304 18.415 10.604C18.415 10.1775 18.1905 9.95238 17.6887 9.95238L9.95238 9.95238L9.95238 17.7067C9.95238 18.0201 10.177 18.2807 10.6379 18.2807C11.0161 18.2807 11.2418 18.0793 11.2418 17.7067L11.2418 12.1586Z",
    fill: "#F39C12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1:154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileclose);
export default __webpack_public_path__ + "static/media/mobileclose.6ea26073fd86a80cc7265f62c274885d.svg";
export { ForwardRef as ReactComponent };